/* eslint-disable import/no-extraneous-dependencies */
import { rest } from 'msw';
import jakeImageSmall from '@/../tests/cypress/e2e/fixtures/icons8-jake-150.png';
import jakeImage from '@/../tests/cypress/e2e/fixtures/icons8-jake-500.png';
import sampleVideo from '@/../tests/cypress/e2e/fixtures/sample_640x360.mp4';
// import sampleZip from '@/../tests/cypress/e2e/fixtures/test.zip';

function mockPNGImageAsset(image, res, ctx) {
  return res(
    ctx.set('Content-Length', image.byteLength.toString()),
    ctx.set('Content-Type', 'image/png'),

    ctx.body(image),
  );
}
export const assetMocksRequests = (msw: typeof rest) => [
  msw.get('https://endpoints.dev.craftsmanplus.com/assets/icons8-jake-150.png', async (_, res, ctx) => {
    const image = await fetch(jakeImageSmall)
      .then((responce) => responce.arrayBuffer());
    return mockPNGImageAsset(image, res, ctx);
  }),

  msw.get('https://endpoints.dev.craftsmanplus.com/assets/icons8-jake-500.png', async (_, res, ctx) => {
    const image = await fetch(jakeImage)
      .then((responce) => responce.arrayBuffer());
    return mockPNGImageAsset(image, res, ctx);
  }),

  msw.get('https://endpoints.dev.craftsmanplus.com/assets/sample_640x360*', async (_, res, ctx) => {
    const video = await fetch(sampleVideo)
      .then((responce) => responce.arrayBuffer());
    return res(
      ctx.set('Content-Length', video.byteLength.toString()),
      ctx.set('Content-Type', 'video/mp4'),
      ctx.body(video),
    );
  }),

  // was not able to get this to work as the zip file is opened as a new page
  // so the mock server is no longer used :'(
  // msw.get('https://endpoints.dev.craftsmanplus.com/assets/test.zip', async (_, res, ctx) => {
  //   const image = await fetch(jakeImageSmall)
  //     .then((responce) => responce.arrayBuffer());
  //   return mockPNGImageAsset(image, res, ctx);
  // }),
];
export default assetMocksRequests;
